.wrapper {
    composes: repeater from "../../styles/layout.module.scss";
}

.root {
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: var(--spacer-16);
}

.content {
    composes: root;
    composes: fullwidth from "../../styles/layout.module.scss";
}

.center {
    composes: root;
    composes: col6 from "../../styles/layout.module.scss";
}

.full {
    composes: root;
    composes: fullbleed from "../../styles/layout.module.scss";
}

.caption {
    composes: fontST16 from "../../styles/typography.module.scss";
}

.root picture {
    display: block;
    max-width: 100%;
}

.root :global(.imageDataWrapper) {
    max-width: 100%;
    overflow: hidden;
}

.root :global(.imageDataWrapper) svg {
    width: 100%;
    height: auto;
}

.img img {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
}

.square {
    composes: img;

    & img {
        aspect-ratio: 1 / 1;
    }
}

.widescreen {
    composes: img;

    & img {
        aspect-ratio: 16 / 9;
    }
}

.film {
    composes: img;

    & img {
        aspect-ratio: 3 / 2;
    }
}

.banner {
    composes: img;

    & img {
        aspect-ratio: 5 / 2;
    }
}

.preserve {
    composes: img;

    & img {
        width: 100%;
    }
}
